import { z } from 'zod';
/**
 * Leaf module for branded ids shared across contract files that would
 * otherwise import each other cyclically. Import ONLY from `zod` here —
 * never from another file in this package. `comments.ts` and `tags.ts` need
 * `ConversationId` but must not import `conversations.ts` (which itself
 * imports `CommentPreviewDTO`/`TagRefDTO` from them): a mutual top-level
 * import would execute the two modules' bodies out of order and hand one of
 * them an uninitialized binding (see the regression test in
 * `comments.test.ts` — reproduced and fixed 2026-09-17, commit 3ae3192
 * review round 1).
 */
/**
 * Branded id for `conversation.id`. Prevents raw-string mix-ups at the type
 * level (e.g. passing a `MessageId` where `ConversationId` is required).
 * Mirrors the `AdminId` pattern in `./admin.ts`.
 *
 * Construct via `ConversationId.parse(rawString)` / `.safeParse(...)` at
 * trust boundaries (HTTP request parsing, DB row mapping). Within the core
 * the type is just `string` at runtime — the brand is a compile-time tag.
 */
export const ConversationId = z.guid().brand();
//# sourceMappingURL=ids.js.map